const MAPBOX_KEY = 'pk.eyJ1IjoiZGF0YW1hY2hpbmEiLCJhIjoiY2sxaDZ3bDI2MTRpdTNjbGJka29nNjFwbyJ9.Eef3UvI4IXVSzmQq3Dkdfg';
const API_URL = 'https://apidev.datamachina.com.br';
const MAP_STYLE = 'mapbox://styles/datamachina/ck8ivb0wi0lp41ipcjmwthk2f' //'mapbox://styles/mapbox/streets-v12'; 

export {
  MAPBOX_KEY,
  API_URL,
  MAP_STYLE,
};
